import { AppState } from '@/vuex/store';
import Task from '../../models/Task';

export default {
  SET_TASKS: (state: AppState, tasks: Task[]) => {
    state.commonState.tasks = tasks;
  },
};
